export function parseEnum<T extends string>(value: string, enumArray: T[]): T | undefined {
  const enumValue = enumArray.find((enumItem) => enumItem === value);
  return enumValue;
}

export function validateNumber(value: string) {
  const parsedValue = parseInt(value);
  return isNaN(parsedValue) ? undefined : parsedValue;
}

export function parseObjectInQueryString({
  queryString,
  keyValueSeparator,
  pairSeparator,
}: {
  queryString: string;
  keyValueSeparator: string;
  pairSeparator: string;
}): Record<string, string> {
  const keyValuePairs = queryString.split(keyValueSeparator);
  return keyValuePairs.reduce(
    (acc, pair) => {
      const [key, value] = pair.split(pairSeparator);
      if (key && value) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string>,
  );
}
